import { useCallback } from 'react';
import { useNavigationStore } from '@base/stores/navigation';
import { buildUrl } from '@utils/buildUrl';
import { getDefined } from '../defined';

const AUTOFUN_CALLBACK_URL = getDefined('PUBLIC_AUTOFUN_CALLBACK_URL');

export const useAutofunUser = (agentId?: string) => {
  const { navigationStore } = useNavigationStore();

  const autofunTokenId = localStorage.getItem('autofun_token_id');
  const isAutofunUser = Boolean(autofunTokenId);

  const redirectToAutofun = useCallback(() => {
    if (!isAutofunUser || !agentId) return;

    const parsedCharacterfile = JSON.parse(navigationStore.characterFile || '');
    const twitterUsername =
      parsedCharacterfile?.settings?.secrets?.TWITTER_USERNAME;

    const autofunUrl = buildUrl(AUTOFUN_CALLBACK_URL, '', {
      queryParams: {
        fleek_agent_id: agentId,
        twitter_username: twitterUsername,
        autofun_token_id: autofunTokenId,
        referral: 'fleek',
      },
    });

    localStorage.removeItem('autofun_token_id');
    window.location.href = autofunUrl;
  }, [isAutofunUser, autofunTokenId, navigationStore.characterFile, agentId]);

  return { isAutofunUser, redirectToAutofun };
};
